<template>
  <svg
    version="1.2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
  >
    <title>matama</title>
    <defs>
      <image
        width="23"
        height="11"
        id="img1"
        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAALCAMAAACj4OZyAAAAAXNSR0IB2cksfwAAATJQTFRFAAAAAFOWAFSVAFSUAFaXAFSWAFOWAFKVAFSWAFSWAFSWAFOXAFSWAFSWAFSVAFSWAFSWAFWWAFSVAFSWAFSWAFSWAFSVAFOUAFSVAFSWAFSWAFSWAFSWAFSVAFSWAFSWAFSWAFCPAFSXAFSWAFWWAFSWAFSWAFSWAFOVAFOWAFSWAFSWAFSWAFaVAFSWAFSWAFSVAFOWAFSWAFSWAFSWAFOXAFOVAFSWAFSWAFSWAFSWAFSTAFSWAFSWAFSWAFSWAFSWAFWUAFOWAFSWAFSWAFSWAFCPAFSWAFSWAFSWAFWVAFSXAFSWAFSVAFSWAFOWAFWVAFSUAFKWAFSWAFSWAFSXAFKXAFCPAFOWAFSWAFSWAFSXAFSVAFSWAFSWAFWVAGaZAFCXAECfAEmSAE+XAAD/qCol2wAAAGZ0Uk5TAEGKGClYCRVnlnAQs/9kw2AVJNzRGmZEq/LFzON7321KBRzUqyPLzTVjkvuAENriFFmUl84FIt5aD9kNadJL7cEsXJO6xAKZ0OwgGeBQdj0xIS3l2B0OASiqoxsqnK8kAQYBAQYA4E1HRQAAAMhJREFUeJxjZIAARjD4BWSxgxhfGaHiPEDOP2bG9wxCIEmgHFycE6TumSjbJ35GxvdCjAqM96Hir5RAMs+lGG9oPpFl1Ga8AhNnYNBlvK/EeIHB8I4qozEj42mYuNnHZ1qMjMfB4lwGjEfB4vpHzNgvqHMBjdrvdNqM0YWRcRdQ3P2YxW2NozZA0YO6wr+POjKqaW4EmR9w/x4Dg5TWeoYgkDJ3RsawVWB3hjMyAh2xFMiKYXygyLgQ5n4GhgRGxnlgRjIj42wGAG+vMbSH2ktTAAAAAElFTkSuQmCC"
      />
    </defs>
    <use id="Background" href="#img1" x="-2" y="6" />
  </svg>
</template>
